import 'picturefill';
import objectFitImages from 'object-fit-images';
import smoothScroll from 'smoothscroll-polyfill';
import './modules/flatpickr';

smoothScroll.polyfill();
objectFitImages(); // {watchMQ: true} break ie11
